// extracted by mini-css-extract-plugin
module.exports = {"noop":"BrokerAssignments_noop__2sQCx","salesAgentErrorLabel":"BrokerAssignments_salesAgentErrorLabel__3lMX5"};